import { useTranslation } from "react-i18next";

import ActionPanelFrame, { ReturnActionPanelProps } from "./ActionPanelFrame";

/** A message on the return, nothing else changes. `initialTemplateKey` starts it from a template (e.g. "own_tracking"). */
export default function MessagePanel({ detail, initialTemplateKey, onConfirm, onCancel, busy }: ReturnActionPanelProps & { initialTemplateKey?: string }) {
  const { t } = useTranslation("returns");
  const isEbay = detail.channel === "ebay";
  return (
    <ActionPanelFrame
      kind="message"
      detail={detail}
      initialTemplateKey={initialTemplateKey}
      confirmLabel={isEbay ? t("Send to eBay") : t("Send")}
      messageHint={isEbay ? t("shown on the return on eBay") : t("kept on the return")}
      onConfirm={(message) => onConfirm({ message })}
      onCancel={onCancel}
      busy={busy}
    />
  );
}
